// Ported from cleverstory-application-v2 reports/components/dropDown.jsx
import React from "react";
import { DropDown } from "src/pages/experiences/storyboardSettings/components/siteSettings/dropdown";
import styles from "./common.module.scss";

export interface ArrangeOption {
  label: string;
  value: string;
  name?: string;
}

interface DropdownFilterProps {
  arrangeOption: ArrangeOption;
  // eslint-disable-next-line no-unused-vars
  handleArrange: (option: { label: string; value: string }) => void;
  disableOption?: string[];
  /** Override the default Views/Visitors/Leads options. */
  options?: { label: string; value: string }[];
}

const OPTIONS = [
  { label: "Views", value: "views" },
  { label: "Visitors", value: "visitors" },
  { label: "Time", value: "timeSpent" },
];

export const DropdownFilter: React.FC<DropdownFilterProps> = ({
  arrangeOption,
  handleArrange,
  disableOption = [],
  options = OPTIONS,
}) => {
  const visibleOptions = options.filter((o) => !disableOption.includes(o.value));
  const dropdownOptions = visibleOptions.map((o) => ({ key: o.value, label: o.label }));

  return (
    <DropDown
      selected={{ key: arrangeOption.value, label: arrangeOption.label }}
      options={dropdownOptions}
      onChange={(key) => {
        const option = visibleOptions.find((o) => o.value === key);
        if (option) {
          handleArrange(option);
        }
      }}
      className={styles.pieChartFilterDropdown}
      align="end"
    />
  );
};
